import { FunctionComponent, HTMLAttributes } from 'react';

const IconEnvelope: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg
    {...props}
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.96154 3.30773L8.5 7.61542L14.0385 3.30773M2.03846 0.846191H14.9615C15.8112 0.846191 16.5 1.53498 16.5 2.38465V11.6154C16.5 12.4651 15.8112 13.1539 14.9615 13.1539H2.03846C1.18879 13.1539 0.5 12.4651 0.5 11.6154V2.38465C0.5 1.53498 1.18879 0.846191 2.03846 0.846191Z"
      stroke="currentcolor"
      strokeMiterlimit="10"
    />
  </svg>
);

export default IconEnvelope;
